// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3gseo","catItem":"styles_catItem__HYUX9"};